export default "__VITE_ASSET__Dwm3orIU__"